import { type ReactNode, type ReactElement } from 'react';
import { FormattedMessage, FormattedNumber } from 'dibs-react-intl';
import { VERTICALS } from '../../constants/uriConstants.ts';
import { type Maybe } from 'dibs-ts-utils/exports/Maybe.ts';

export const categoryLabel = (
    <FormattedMessage id="sb.SbSharedRecentSalesMessages.category" defaultMessage="Category" />
);

const priceLabel = (
    <FormattedMessage id="sb.SbSharedRecentSalesMessages.price" defaultMessage="Price" />
);

const soldPriceLabel = (
    <FormattedMessage id="sb.SbSharedRecentSalesMessages.soldPrice" defaultMessage="Sold Price" />
);

const soldDateLabel = (
    <FormattedMessage id="sb.SbSharedRecentSalesMessages.soldDate" defaultMessage="Sold Date" />
);
export const mediumLabel = (
    <FormattedMessage id="sb.SbSharedRecentSalesMessages.medium" defaultMessage="Medium" />
);
export const materialLabel = (
    <FormattedMessage id="sb.SbSharedRecentSalesMessages.material" defaultMessage="Material" />
);
export const periodLabel = (
    <FormattedMessage id="sb.SbSharedRecentSalesMessages.period" defaultMessage="Period" />
);
export const creationYearLabel = (
    <FormattedMessage
        id="sb.SbSharedRecentSalesMessages.creationYear"
        defaultMessage="Creation Year"
    />
);

export const recentSalesAveragePriceDetails = (
    <FormattedMessage
        id="sb.SbSharedRecentSalesMessages.averageSoldPriceDetails"
        defaultMessage="Average sold price of items in the past 12 months"
    />
);

export const recentSalesPriceRangeDetails = (
    <FormattedMessage
        id="sb.SbSharedRecentSalesMessages.priceRangeDetails"
        defaultMessage="Sold price range of items in the past 12 months"
    />
);

export const recentSalesTitle = (creator: string): ReactNode => (
    <FormattedMessage
        id="sb.SbSharedRecentSalesMessages.recentSalesTitle"
        defaultMessage="{creator} Sale Prices"
        values={{ creator }}
    />
);

export const recentSalesAbout = (
    <FormattedMessage
        id="sb.SbSharedRecentSalesMessages.recentSalesAbout"
        defaultMessage="About Recent Sales on 1stDibs"
    />
);

export const recentSalesDescription = (
    <FormattedMessage
        id="sb.SbSharedRecentSalesMessages.recentSalesDescription"
        defaultMessage="This data represents a recent sample of sales made on 1stDibs during the specified years. All sales are anonymized."
    />
);

export const recentSalesPriceRangeInfo = ({
    minPrice,
    maxPrice,
    currency,
}: {
    minPrice: number;
    maxPrice: number;
    currency: string;
}): ReactNode => (
    <>
        <FormattedNumber
            value={minPrice}
            style="currency"
            currency={currency}
            maximumFractionDigits={0}
            minimumFractionDigits={0}
        />
        -
        <FormattedNumber
            value={maxPrice}
            style="currency"
            currency={currency}
            maximumFractionDigits={0}
            minimumFractionDigits={0}
        />
    </>
);

export const getRecentSalesHeaders = ({
    isMobile,
    topVertical,
}: {
    isMobile?: boolean;
    topVertical: Maybe<string>;
}): Array<ReactElement> => {
    let headerLabels = isMobile
        ? [priceLabel, soldDateLabel]
        : [soldDateLabel, soldPriceLabel, categoryLabel];

    if (topVertical === VERTICALS.FASHION) {
        headerLabels = [...headerLabels, periodLabel];
    } else {
        const madeOfLabel = topVertical === VERTICALS.ART ? mediumLabel : materialLabel;
        headerLabels = [...headerLabels, madeOfLabel, creationYearLabel];
    }

    return headerLabels;
};
